module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Plus Gold.a74fc637.png";